import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

export default class MultiSelectFilter extends React.Component {
  static propTypes = {
    filterHandler: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    filterCallback: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.filter = this.filter.bind(this);
    this.isFiltered = this.isFiltered.bind(this);
    this.state = {};
  }

  filter(selectedValues) {
    this.state.selectedValues = selectedValues;
    if (selectedValues.length === 0 || selectedValues.length === this.props.options.length) {
      // all or no values are selected means we want to remove the filter for this column
      this.props.filterHandler();
    } else {
      this.props.filterHandler({ callback: this.isFiltered });
    }
  }

  isFiltered(targetValue, row) {
    if (this.props.filterCallback) {
      return this.props.filterCallback(targetValue, this.state.selectedValues);
    } else {
      return this.state.selectedValues.some((val) => val.value === targetValue);
    }
  }

  render() {
    return <div style={{ position: 'absolute' }} ><Select value={this.state.selectedValues} multi={true} options={this.props.options} onChange={this.filter} /></div>;
  }
}